export default __webpack_public_path__ + "static/media/casaduana_bannerHome_movil.dc3d5adc.jpg";